import type { LeadFlowAnswers } from "../types";

import { CONTRACT_SHAPE } from "../constants/contract-shape";

type SingleChoiceFieldName = "careFor" | "urgency";

/**
 * Whether an authored option value is one the contract accepts for the
 * field. Studio validates option values against the contract, so this only
 * rejects content that drifted from it.
 */
function isChoiceValue<TFieldName extends SingleChoiceFieldName>(
  fieldName: TFieldName,
  value: unknown,
): value is NonNullable<LeadFlowAnswers[TFieldName]> {
  return (
    value !== undefined &&
    value !== null &&
    CONTRACT_SHAPE[fieldName].safeParse(value).success
  );
}

export { isChoiceValue };
